import { render, staticRenderFns } from "./CardOrderComplete.vue?vue&type=template&id=8e6fdcac&scoped=true"
import script from "./CardOrderComplete.vue?vue&type=script&lang=ts"
export * from "./CardOrderComplete.vue?vue&type=script&lang=ts"
import style0 from "./CardOrderComplete.vue?vue&type=style&index=0&id=8e6fdcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6fdcac",
  null
  
)

export default component.exports